export default __webpack_public_path__ + "static/media/close_logo.e2e11425.svg";